

      var cents, doubleMoney, i, j, len, len1, money, ref, ref1;
      Currency.format = 'money_format';
      Currency.money_with_currency_format = {};
      Currency.money_with_currency_format[Shop.currency] = Shop.moneyFormatCurrency;
      Currency.money_format = {};
      Currency.money_format[Shop.currency] = Shop.moneyFormat;

      Currency.currentCurrency = Shop.currency;
      
      //window.cookieCurrency = Currency.cookie.read() ? Currency.cookie.read() : Shop.currency;

      // if (window.cookieCurrency === null) {
      //   Currency.currentCurrency = Shop.currency;
      // } else if ($("[name=currencies]").length && $("[name=currencies] option[value='" + window.cookieCurrency + "']").length === 0) {
      //   Currency.currentCurrency = Shop.currency;
      //   Currency.cookie.write(Shop.currency);
      // } else if (window.cookieCurrency === Shop.currency) {
      //   Currency.currentCurrency = Shop.currency;
      // } else {
      //   Currency.convertAll(Shop.currency, window.cookieCurrency);
      // }
/*
      if (window.cookieCurrency) {
        $("[name=currencies]").val(window.cookieCurrency);
      }
      ref = $("span.money span.money");
      for (i = 0, len = ref.length; i < len; i++) {
        doubleMoney = ref[i];
        $(doubleMoney).parents("span.money").removeClass("money");
      }
      ref1 = $("span.money");
      for (j = 0, len1 = ref1.length; j < len1; j++) {
        money = ref1[j];
        $(money).attr("data-currency-" + Shop.currency, $(money).html());
        if (Currency.format === "money_with_currency_format") {
          cents = parseInt($(money).html().replace(/[^0-9]/g, ""), 10);
          $(money).attr("data-currency-" + Shop.currency, Shopify.formatMoney(cents, Shop.moneyFormat));
          $(money).html(Shopify.formatMoney(cents, Shop.moneyFormat));
        }
      }
      switchCurrency();
      $("[name=currencies]").val(Currency.currentCurrency);

function convertAll(e, variant, selector) {
  console.log('>>> convertall')
  var newCurrency;
  newCurrency = $('#currencies').val();
  Currency.convertAll(Currency.currentCurrency, newCurrency);
  $(".selected-currency").text(Currency.currentCurrency);
  return window.cookieCurrency = newCurrency;
}

function switchCurrency() {
  // console.log('switchCurrency');
  //       if (window.cookieCurrency === null) {
  //       return Currency.currentCurrency = Shop.currency;
  //     } else if ($("[name=currencies]").length && $("[name=currencies] option[value='" + window.cookieCurrency + "']").length === 0) {
  //       Currency.currentCurrency = Shop.currency;
  //       return Currency.cookie.write(Shop.currency);
  //     } else if (window.cookieCurrency === Shop.currency) {
  //       return Currency.currentCurrency = Shop.currency;
  //     } else {
  //       return Currency.convertAll(Shop.currency, window.cookieCurrency);
  //     }
}*/

// accessibility for cart modal

$( document ).ready(function() {
  let observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.addedNodes[0] && mutation.addedNodes[0].id == "usi_container") {
        var element = document.querySelector('#usi_display');
        element.setAttribute("tabindex","0");
        setTimeout(() => element.focus(), 50);
      }
    });
  });

  observer.observe(document.body, {
    childList: true, 
  });
});

(function ($) {

  'use strict';

  var lg = {
    /**
     * Init Function
     */
    init: function () {
      lg.newsletter();
      lg.nav();
      lg.dropdown();
      lg.scrollLinks();
      lg.select();
      lg.passwordBox();
      lg.quantityCart();
      lg.carousel();
      lg.carouselHome();
      lg.popover();
      lg.carouselProduct();
      lg.customScroll();
      lg.dutiesIncludedPDP();

      if($('.iwishWrapper').length) {
        $('.iwishWrapper').wrap('<div class="lg-container"><div class="lg-row"><div class="lg-col-12"></div></div></div>')
      }

      // if (window.cookieCurrency) {
      //   $("[name=currencies]").val(window.cookieCurrency);
      // }
      // ref1 = $(".product-price-minimum");
      // for (j = 0, len1 = ref1.length; j < len1; j++) {
      //   money = ref1[j];
      //   $(money).attr("data-currency-" + Shop.currency, $(money).html());
      //   if (Currency.format === "money_with_currency_format") {
      //     cents = parseInt($(money).html().replace(/[^0-9]/g, ""), 10);
      //     $(money).attr("data-currency-" + Shop.currency, Shopify.formatMoney(cents, Shop.moneyFormat));
      //     $(money).html(Shopify.formatMoney(cents, Shop.moneyFormat));
      //   }
      // }
// $('#currencies').on('change', function(e) {
//   console.log($(this).val());
//   //Currency.cookie.write($(this).val());
//   var newCurrency;
//   newCurrency = $('#currencies').val();
//   //console.log(Currency.currentCurrency, newCurrency);
//   Currency.convertAll(Currency.currentCurrency, newCurrency);
//   window.cookieCurrency = newCurrency;
//   //Currency.cookie.write($(this).val());
//   //$.cookie('currency', $(this).val(), { expires: 30 });
//   //switchCurrency();
// });

  // $('.selected-currency').html($('.selected-currency').html() + getcurrecnySym($('.selected-currency').html()));
  //   $('#currencies option').each(function(){
  //   $(this).html($(this).html() + getcurrecnySym($(this).html()));
  // });

  $('.product-sizechart').click(function(){
    showPopup();
  });
  $('#pp-overlay').click(function(){
  hidePopup();
  });
  $('#hide-size-guide').click(function(){
    hidePopup();
  });
  if($('.gallery-item').length) {

$('.lg-product-item:not(.slick-cloned) .gallery-item').magnificPopup({
  callbacks: {
    open: function() {
      var magnificPopup = $.magnificPopup.instance;
      var closeButton = document.getElementsByClassName('mfp-close')[0];
      $(closeButton).attr('aria-label', 'Close');
      magnificPopup.wrap.attr({ role: 'dialog', 'aria-label': 'Magnified image carousel' });
      magnificPopup.container.attr({ tabindex: '-1', 'aria-live': 'polite' })
    } 
  },
  type: 'image',
  gallery:{
    enabled:true
  },
  disableOn: 767
});
$('.gallery-item').on('click', function() {
  if($(window).width() < 768) {
    return false;
  }
});
}

      $(".lg-sort-menu a").on('click', function() {

        return false;
      });
    },
    // Newsletter footer
    newsletter: function () {
      $('.lg-news-show').on('click', function () {
        $(this).hide();
        $('.lg-signup').show();
      });
    },
    nav: function () {
      //Mobile Menu
      $('.lg-toggle-menu').on('click', function () {
        if ($(window).width() <= 1024) {
          $('body').toggleClass('lg-open-menu-mobile');
        }
        return false;
      });

      $('.lg-menu-overlay').on('click', function() {
        $('body').removeClass('lg-open-menu-mobile');
        $('body').removeClass('lg-open-menu-shopping-mobile');
        $('body').removeClass('lg-open-menu-filter-mobile');
      });

      if ($('.lg-toggle-menu').length) {
        $(window).on('resize', function () {
          if ($(window).width() > 1024) {
            $('body').removeClass('lg-open-menu-mobile');
          }
        });
      }

      //Shopping Menu
      $('.lg-toggle-menu-shopping').on('click', function () {
        if ($(window).width() <= 1024) {
          $('body').toggleClass('lg-open-menu-shopping-mobile');
        }
        return false;
      });

      if ($('.lg-toggle-menu-shopping').length) {
        $(window).on('resize', function () {
          if ($(window).width() > 1024) {
            $('body').removeClass('lg-open-menu-shopping-mobile');
          }
        });
      }

      //Filter Menu
      $('.lg-toggle-menu-filter').on('click', function () {
        if ($(window).width() <= 1024) {
          $('body').toggleClass('lg-open-menu-filter-mobile');
        }
        return false;
      });

      if ($('.lg-toggle-menu-filter').length) {
        $(window).on('resize', function () {
          if ($(window).width() > 1024) {
            $('body').removeClass('lg-open-menu-filter-mobile');
          }
        });
      }

      //Color Menu
      $('.lg-toggle-color').on('click', function () {
        if ($(window).width() <= 990) {
          $('.lg-nav-color').slideToggle();
          $(this).toggleClass('lg-toggle-color-selected');
        }
        return false;
      });

      //Sort
      $(".lg-toggle-sort").click(function () {
        $('.lg-toggle-sort-active').removeClass('lg-toggle-sort-active');
        $(".lg-sort-menu").slideToggle();
        return false;
      });

      if(window.location.search == '?sort_by=price-descending') {
        $('.lg-toggle-sort').text('$ High to Low');
        $('.lg-sort-menu ul li:nth-child(3)').remove();
      }

      if(window.location.search == '?sort_by=price-ascending') {
        $('.lg-toggle-sort').text('$ Low to High');
        $('.lg-sort-menu ul li:nth-child(2)').remove();
      }

      if(window.location.search == '?sort_by=newest') {
        $('.lg-toggle-sort').text('Newest');
        $('.lg-sort-menu ul li:nth-child(1)').remove();
      }

      if(window.location.search == '') {
        $('.lg-sort-menu ul li:nth-child(1)').remove();
      }

      $(".lg-sort-menu a").click(function (event) {
        event.preventDefault();
        //$(".lg-toggle-sort").html($(this).text()).addClass('lg-toggle-sort-active');

        var target = $(this).data('order');
        window.location.search = target;
      });

      //Search
      $('.lg-toggle-search,.lg-toggle-search-desktop').on('click', function () {
        $('.lg-search-box').toggleClass('lg-search-box-open');
        if($('.lg-search-box').hasClass('lg-search-box-open')) {
          setTimeout(function() {
            $('#desktopSearchInput').focus();
          }, 500);
        }
        return false;
      });

      $('.lg-close-box-search').on('click', function () {
        $('.lg-search-box').removeClass('lg-search-box-open');
        return false;
      });
    },
     // Dropdown
    dropdown: function () {
      $('.accordion-toggle').on('click', function () {
        var dropdown = $(this).attr('data-target');
        $(dropdown).slideToggle();
        return false;
      });



//       $(".dropdown-currency a").click(function (event) {
//         event.preventDefault();
//         $(".lg-dropdown-currency-container .lg-btn-toggle").html($(this).text());
//         $(this).closest('.lg-dropdown').hide();

//       if (window.cookieCurrency === null) {
//         return Currency.currentCurrency = Shop.currency;
//       } else if ($("[name=currencies]").size() && $("[name=currencies] option[value='" + window.cookieCurrency + "']").size() === 0) {
//         Currency.currentCurrency = Shop.currency;
//         return Currency.cookie.write(Shop.currency);
//       } else if (window.cookieCurrency === Shop.currency) {
//         return Currency.currentCurrency = Shop.currency;
//       } else {
//         return Currency.convertAll(Shop.currency, window.cookieCurrency);
//       }








// //var minimumPriceArea = $(".product-price-minimum");


//       //var attribute, j, len, ref1;
//       // ref1 = minimumPriceArea[0].attributes;
//       // for (j = 0, len = ref1.length; j < len; j++) {
//       //   attribute = ref1[j];
//       //   if (attribute.name.indexOf("data-") > -1) {
//       //     minimumPriceArea.attr(attribute.name, "");
//       //   }
//       // }
//       //Currency.currentCurrency = $(this).attr('data-curr');
//       //console.log(Currency.currentCurrency, Shop.currency, Shopify.formatMoney($('.product-price-minimum').data('vprice'), Shop.moneyFormat), slate.Currency.formatMoney($('.product-price-minimum').data('vprice'), ));
//       //minimumPriceArea.attr("data-currency-" + Currency.currentCurrency, "").attr("data-currency-" + Shop.currency, Shopify.formatMoney($('.product-price-minimum').data('vprice'), Shop.moneyFormat)).attr("data-currency", Shop.currency);
//       //$(".product-price-compare").attr("data-currency-" + Shop.currency, Shopify.formatMoney($('.product-price-minimum').data('vcprice'), Shop.moneyFormat)).attr("data-currency", Shop.currency);
//       //return $(".currency-switcher").trigger("reset-currency");

//       // var attribute, j, len, ref1;
//       // ref1 = minimumPriceArea[0].attributes;
//       // for (j = 0, len = ref1.length; j < len; j++) {
//       //   attribute = ref1[j];
//       //   if (attribute.name.indexOf("data-") > -1) {
//       //     minimumPriceArea.attr(attribute.name, "");
//       //   }
//       // }
//       /*
//       minimumPriceArea.attr("data-currency-" + $(this).data('curr'), "");
// //console.log(Shopify.formatMoney($('.product-price-minimum').attr('data-vprice')));
//       minimumPriceArea.attr("data-currency-" + $(this).data('curr'), Shopify.formatMoney($('.product-price-minimum').data('vprice'), Shop.moneyFormat));
//       minimumPriceArea.attr("data-currency", $(this).data('curr'));
//       $(".product-price-compare").attr("data-currency-" + Shop.currency, Shopify.formatMoney($('.product-price-minimum').data('vcprice'), Shop.moneyFormat)).attr("data-currency", Shop.currency);
// */

//         //return false;
//       });

    },
     // Scroll Links
    scrollLinks: function () {
      $('.lg-list-nav a').on('click', function () {
        var target = $(this).attr('href');
        if (target == '#') {
          $('html, body').animate({
            'scrollTop': 0
          }, 900);
        } else {
          var offset = $(target).offset();
          offset = offset.top - 20;
          $('html, body').animate({
            'scrollTop': offset
          }, 900);
        }
        $('html, body').animate({
          'scrollTop': offset
        }, 900);
        return false;
      });
    },
     //Custom Select
    select: function () {
      $(".lg-single-option-selector").change(function (event) {
//        event.preventDefault();
        $(".lg-select-text").html($('.lg-single-option-selector option:selected').text());
        $('#sizes input[value='+$(this).val()+']').prop("checked", true);
      });

      $('.lg-product-list-item').each(function() {
        var inputCount = $(this).find('.lg-selector-wrapper input').length;
        if(inputCount === 1) {
          $(this).find('.lg-selector-wrapper input').attr('checked', true);
        }
      });
    },
     // Password
    passwordBox: function () {
      $('.lg-btn-swap').on('click', function () {
        $('.lg-recover-password').show();
        $('.lg-customer-login').hide();
        return false;
      });

      $('.lg-btn-cancel').on('click', function () {
        $('.lg-recover-password').hide();
        $('.lg-customer-login').show();
        return false;
      });
    },
     // Quantiy Checkout
    quantityCart: function () {
      $('.lg-cart-item-decrease').click(function () {
        var target = $(this).siblings('.lg-cart-item-quantity-display');
        var currentQuantity = $(target).val();
        if (currentQuantity > 0) {
          $(target).val(--currentQuantity);
        }
      });

      $('.lg-cart-item-increase').click(function () {
        var target = $(this).siblings('.lg-cart-item-quantity-display');
        var currentQuantity = $(target).val();
        $(target).val(++currentQuantity);
      });
    },
     // Carousel - Editorial
    carousel: function () {
       var $slider = $('.lg-carousel');
      if ($slider.length) {
        $slider.slick({
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          adaptiveHeight: true
        });
      }
    },
     // Carousel - Home
    carouselHome: function () {
       var $sliderH = $('.lg-home-carousel');
      if ($sliderH.length) {
        $sliderH.slick({
          dots: false,
          infinite: true,
          arrows: false,
          fade: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: true
        });
      }
    },
    // Popover
    popover: function() {
      $('.lg-close-popover').on('click', function() {
        var $popoverShow = $(this).closest('.lg-popover');
        if($popoverShow.hasClass('lg-popover-show')) {
          $('.lg-popover-show').hide();
        }
        return false;
      });
    },
      // Carousel - Product
    carouselProduct: function () {
       var $sliderproduct = $('.lg-carousel-product');
      if ($sliderproduct.length) {
       $sliderproduct.slick({
          infinite: true,
          focusOnChange: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          prevArrow: '<span class="btn-wrap slick-prev"><button type="button" class="">Previous</button></span>',
          nextArrow: '<span class="btn-wrap slick-next"><button type="button" class="">Next</button></span>'
        });
      }
    },

    customScroll: function() {
      if($('ul#shopify-section-designers').length) {
        $('ul#shopify-section-designers').mCustomScrollbar();
      }
    },

    dutiesIncludedPDP: function () {
      $("[src^='//gepi.global-e.com/includes/js/']").on('load', function () {
        $("[src^='https://web.global-e.com/merchant/clientsdk/']").on('load', function () {
          window.GlobalE.OnLoadCallBack = function() {
            var currentCountryCode = window.GlobalE.Country.toLowerCase();        
            $('.lg-add-info').each(function() {
              var listOfCountryCodes = $(this).data('countrycode').toLowerCase();
              if(listOfCountryCodes.indexOf(currentCountryCode) > -1) {
                $(this).show();
              }
            });
          }
        })
      })
    }
  };

  $(function () {
    lg.init();
  });

})(jQuery);

  function showPopup() {
    $('#pp-popup').fadeIn(500);
  $('#pp-overlay').fadeIn(500);
  }
  
  function hidePopup() {
  $('#pp-popup').fadeOut(500);
  $('#pp-overlay').fadeOut(500);
  }

//   function getcurrecnySym(currency) {
//     if (currency == 'EUR') {
//         return ' €';
//     } else if (currency == 'GBP') {
//         return ' £';
//     } 
//     else if (currency == 'CNY') {
//         return ' ¥';
//     }
//       else if (currency == 'JPY') {
//         return ' ¥';
//     }
//     else if (currency == 'KRW') {
//         return ' ₩';
//     }else {
//         return ' $';
//     }
// }

$(document).ready(function() {
  if($('#collection-carousel').length) {
    $('#collection-carousel').slick({
      'adaptiveHeight': true,
      'dots': true,
      'mobileFirst': true
    });
  }
});